import { FC, useEffect } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import Header from '@/components/XPower/elements/Header';
import { GuardIcon } from '@/components/XPower/svg';
import { EU_LIST } from '@/components/XPower/constants';
import getLocal from '@/app/utils/getLocal';

const XGuard: FC = () => {
    const { t } = useLang('xcode.xguard');
    const { locale } = getLocal();

    let firstImg = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719212318389/Mask%20group.jpg';
    const list = [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719212370291/Mask%20group-1.jpg',
            tips: t('section_tips1'),
            title: t('section_title1'),
            desc: t('section_desc1'),
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719212384427/Mask%20group-2.jpg',
            tips: t('section_tips2'),
            title: t('section_title2'),
            desc: t('section_desc2'),
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719212396808/Mask%20group-3.jpg',
            tips: t('section_tips3'),
            title: t('section_title3'),
            desc: t('section_desc3'),
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718704509238/%E8%8A%AF%E7%89%87-PC%20(1).jpg',
            tips: t('section_tips4'),
            title: t('section_title4'),
            desc: t('section_desc4'),
        },
    ];

    if (EU_LIST.includes(locale)) {
        firstImg =
            'https://websiteoss.ecoflow.com/upload/image/1724739413904/%E6%B8%B2%E6%9F%93%E5%8A%A8%E6%95%88%E6%B1%87%E6%80%BB-1%20%E6%AC%A7%E8%A7%84%20%E6%8B%B7%E8%B4%9D%201%20(1).jpg';
        list[0].img = firstImg;
        list[1].img =
            'https://websiteoss.ecoflow.com/upload/image/1724739435746/%E6%B8%B2%E6%9F%93%E5%8A%A8%E6%95%88%E6%B1%87%E6%80%BB%20%E6%AC%A7%E8%A7%84%20%E6%8B%B7%E8%B4%9D%202%20(1).jpg';
        if (locale === 'uk') {
            firstImg = 'https://websiteoss.ecoflow.com/upload/image/1724739726351/uk1.jpg';
            list[0].img = firstImg;
            list[1].img = 'https://websiteoss.ecoflow.com/upload/image/1724739761856/uk2.jpg';
        }
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                asyncFromTo: [[`.first .left`, { y: -100 }, { y: 0 }, 1]],
                // asyncTimeLine: [2, 1, 4, 5, 6, 7, 8, 9, 10, 11],
                triggerElement: `.first`,
                triggerHook: 1,
                offset: '10%',
                duration: '100%',
            });
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    [`.${styled.XGuard} .subtitle`, { y: 0 }, { y: -100 }, 1],
                    // [`.${styled.XGuard} .first .left`, { y: -200 }, { y: 0 }, 1],

                    [`.${styled.XGuard} .section_0`, { opacity: 0 }, { opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_0 .right`, { y: 200, opacity: 0 }, { y: 50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_0 .right`, { y: 50, opacity: 1 }, { y: -50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_0 .right`, { y: -50, opacity: 1 }, { y: -200, opacity: 0 }, 1],
                    // 暂停
                    // [`.${styled.XGuard} .section_0 .right`, { y: 0, opacity: 1 }, { y: 0, opacity: 1 }, 1],

                    // 第二个
                    [`.${styled.XGuard} .section_1`, { opacity: 0 }, { opacity: 1 }, 1],
                    // [`.${styled.XGuard} .section_0 .right`, { y: 0, opacity: 1 }, { y: -200, opacity: 0 }, 1],

                    [`.${styled.XGuard} .section_1 .right`, { y: 200, opacity: 0 }, { y: 50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_1 .right`, { y: 50, opacity: 1 }, { y: -50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_1 .right`, { y: -50, opacity: 1 }, { y: -200, opacity: 0 }, 1],
                    // 暂停
                    // [`.${styled.XGuard} .section_1 .right`, { y: 0, opacity: 1 }, { y: 0, opacity: 1 }, 1],
                    // [`.${styled.XGuard} .section_1 .right`, { y: 0, opacity: 1 }, { y: -200, opacity: 0 }, 1],

                    // 第三个
                    // [`.${styled.XGuard} .section_1 .right`, { y: 0, opacity: 1 }, { y: -200, opacity: 0 }, 1],
                    [`.${styled.XGuard} .section_2`, { opacity: 0 }, { opacity: 1 }, 1],

                    [`.${styled.XGuard} .section_2 .right`, { y: 200, opacity: 0 }, { y: 50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_2 .right`, { y: 50, opacity: 1 }, { y: -50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_2 .right`, { y: -50, opacity: 1 }, { y: -200, opacity: 0 }, 1],
                    // 暂停
                    // [`.${styled.XGuard} .section_2 .right`, { y: 0, opacity: 1 }, { y: 0, opacity: 1 }, 1],
                    // [`.${styled.XGuard} .section_2 .right`, { y: 0, opacity: 1 }, { y: -200, opacity: 0 }, 1],

                    // 第四个
                    [`.${styled.XGuard} .section_3`, { opacity: 0 }, { opacity: 1 }, 1],

                    [`.${styled.XGuard} .section_3 .right`, { y: 200, opacity: 0 }, { y: 50, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_3 .right`, { y: 50, opacity: 1 }, { y: 0, opacity: 1 }, 1],
                    [`.${styled.XGuard} .section_3 .right`, { y: 0, opacity: 1 }, { y: 0, opacity: 1 }, 1],
                ],
                // asyncTimeLine: [2, 1, 4, 5, 6, 7, 8, 9, 10, 11],
                triggerElement: `.${styled.XGuard}`,
                triggerHook: 1,
                offset: '150%',
                duration: '500%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene([scene, sceneA]);
        }
    }, []);

    return (
        <div className={styled.XGuard}>
            <Header icon={<GuardIcon />} desc={t('title')} subtitle={t('subtitle')} />
            {/* pc端 */}
            <div className="pc section_central">
                <div className="section_sticky">
                    <div className="section_item first">
                        <div className="left">
                            <EditorImg pc={firstImg} alt={t('title')} />
                        </div>
                        <div className="right"></div>
                    </div>
                    {list.map((item, index) => (
                        <div key={index} className={`section_item section_${index}`}>
                            <div className="left">
                                <EditorImg pc={item.img} alt={item.title} />
                            </div>
                            <div className="right">
                                <p className="tips">{item.tips}</p>
                                <p className="title">{item.title}</p>
                                <p className="desc font-desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* mobile端 */}
            <div className="mobile">
                {list.map((item, index) => (
                    <div key={index} className="mobile_item">
                        <div className="top">
                            <EditorImg pc={item.img} alt={item.title} />
                        </div>
                        <div className="bottom">
                            <p className="tips">{item.tips}</p>
                            <p className="title">{item.title}</p>
                            <p className="desc font-desc">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default XGuard;
